import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

const LastAvailables = new Mongo.Collection("LastAvailables", {
    connection: null
});

/**
 * @class
 * Responsavel por cuidar dos dados dos Availables usados no dashboard
 *
 *
 */
export class LastAvailable extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDataTimeseries = `${publicSettings.aws.baseUrls.dataTimeseries}`;

    constructor() {
        super(LastAvailables);
    }

    async getLastDates({ accountingId, companyIds, so } = {}) {
        if (!accountingId || !so) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/availables-last-dates`,
                { accountingId, companyIds, so }
            );
            return response;
        } catch (error) {
            throw new Error(
                error?.message || "Erro ao buscar datas disponíveis"
            );
        }
    }
}
